import { log } from 'logger';

export default label => {
  return req => {
    const apiLabel = label || req.url;
    const start = new Date().getTime();

    req.on('error', err => log.error({ err, apiRequest: req }, `API error: ${apiLabel}`));
    req.on('response', res => {
      const now = new Date().getTime();
      const latency = now - start;
      const fields = { apiRequest: req, apiResponse: res, latency };
      const msg = `API response: ${apiLabel}`;

      if (res.statusCode < 400) {
        log.info(fields, msg);
      } else {
        log.error(fields, msg);
      }
    });
  };
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/request-logger/index.js
 **/